<template>
  <v-content>
    <v-container fluid>
      <v-card class="elevation-5">
        <v-toolbar dense dark color="deep-orange" elevation="2">
          <v-toolbar-title>Tipos de servicio</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="dialogNew = true">
            Agregar
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title>
          <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="refresh()">
            Actualizar
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="view()">
            Editar
            <v-icon right>mdi-pencil</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="dialogRemove = true">
            Eliminar
            <v-icon right>mdi-delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
        </v-card-title>
        <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" :search="search"
        :footer-props="{ 'items-per-page-text': 'Elementos por página' }" :items-per-page="5" item-key="id"
        single-select show-select class="elevation-1">
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template v-slot:footer.page-text="props">
            Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
          <template v-slot:no-data>
            No hay información disponible
          </template>
          <template v-slot:no-results>
            No se obtuvieron resultados
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogNew" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Nuevo registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="save()">
              Guardar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formNew" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.idexterno" label="Idexterno" :rules="formRules.idexterno" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.nombre" label="Nombre" :rules="formRules.nombre" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.descripcion" label="Descripción" :rules="formRules.descripcion" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdate" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Actualizar registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="update()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formUpdate" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.idexterno" label="Idexterno" :rules="formRules.idexterno" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.nombre" label="Nombre" :rules="formRules.nombre" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.descripcion" label="Descripción" :rules="formRules.descripcion" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRemove" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text>¿Realmente desea eliminar el registro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" color="primary" @click="cancel()">
              Cancelar
            </v-btn>
            <v-btn text small :loading="loading" color="error" @click="remove()">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
import services from '@/utils/services'

export default {
  name: 'tiposservicio',
  data: () => ({
    loading: false,
    error: false,
    msgError: '',
    success: false,
    msgSuccess: '',
    search: '',
    headers: [
      { text: 'Idexterno', align: 'center', sortable: false, value: 'idexterno' },
      { text: 'Nombre', align: 'center', sortable: false, value: 'nombre' },
      { text: 'Descripción', align: 'center', sortable: false, value: 'descripcion' },
      { text: 'Fecha actualización', align: 'center', sortable: false, value: 'fecha_cambio' }
    ],
    items: [],
    selected: [],
    dialogNew: false,
    dialogUpdate: false,
    dialogRemove: false,
    formNew: {
      idexterno: '',
      nombre: '',
      descripcion: '',
    },
    formUpdate: {
      id: '',
      idexterno: '',
      nombre: '',
      descripcion: ''
    },
    formRules: {
      idexterno: [
        v => !!v || 'El idexterno es obligatorio',
        v => (v && v.length <= 50) || 'El idexterno excede la longitud máxima'
      ],
      nombre: [
        v => !!v || 'El nombre es obligatorio',
        v => (v && v.length <= 50) || 'El nombre excede la longitud máxima'
      ],
      descripcion: [
        v => !!v || 'La descripción es obligatoria',
        v => (v && v.length <= 150) || 'La descripción excede la longitud máxima'
      ]
    }
  }),
  mounted() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      services.ws('get', 'tiposServicios')
        .then(res => {
          if (res.ok) {
            this.items = res.data.tipos_servicios
            this.selected = []
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    clear() {
      if (this.$refs.formNew) {
        this.$refs.formNew.reset()
      }
      else if (this.$refs.formUpdate) {
        this.$refs.formUpdate.reset()
      }
      for (let key in this.formNew) {
        this.formNew[key] = ''
      }
      for (let key in this.formUpdate) {
        this.formUpdate[key] = ''
      }
    },
    cancel() {
      this.clear()
      this.selected = []
      this.dialogNew = false
      this.dialogUpdate = false
      this.dialogRemove = false
    },
    save() {
      if (this.$refs.formNew.validate()) {
        this.loading = true
        setTimeout(() => {
          services.ws('post', 'nuevoTipoServicio', this.formNew)
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    view() {
      this.formUpdate = JSON.parse(JSON.stringify(this.selected[0]))
      this.dialogUpdate = true
    },
    update() {
      if (this.$refs.formUpdate.validate()) {
        this.loading = true
        setTimeout(() => {
          services.ws('post', 'actualizarTipoServicio', this.formUpdate)
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    remove() {
      this.loading = true
      setTimeout(() => {
        let id = this.selected[0].id
        services.ws('post', 'eliminarTipoServicio', { id })
          .then(res => {
            if (res.ok) {
              this.cancel()
              this.refresh()
              this.success = true
              this.msgSuccess = res.message
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 800)
    }
  }
}
</script>
